import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { DataFormatService } from '../../../services/data-format.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { update_project_participants } from './graphql/editParticipants';
import { participants_search_people } from './graphql/participantsSearchPeople';
import { Apollo } from 'apollo-angular';
import { FormControl, isFormGroup } from '@angular/forms';
import { ApiService } from 'src/app/api/api.service';
import { EnvironmentService } from 'src/app/environment/environment.service';
import { debounceTime, distinctUntilChanged, Subscription } from 'rxjs';
import { BehaviorSubject, Observable } from 'rxjs';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { UserPermissionsService } from 'src/app/services/user-permissions.service';

const UPDATE_PROJECT_PARTICIPANTS = update_project_participants;
const PARTICIPANTS_SEARCH_PEOPLE = participants_search_people;

export interface CREATable {
  role: string;
  participant: string;
  url: string;
  originatorRelationship: boolean | null;
}

export interface ThirdPartyTable {
  role: string;
  participant: string;
  url: string;
  sponsor: string;
  sponsorurl: string;
  is_repeat: string;
  tags: string;
}

export interface SponsorTable {
  role: string;
  participant: string;
  is_repeat: string;
  url: string;
}

@Component({
    selector: 'deal-participants',
    templateUrl: './participants.component.html',
    styleUrls: ['./participants.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ParticipantsComponent implements OnInit {
  @Input() participants$: Observable<any>;
  @Input() developer: any;
  @Input() roles: any;
  @Input() projectid: any;
  @Output() participantsChange: EventEmitter<any> = new EventEmitter();
  @ViewChild('creaSort') public creaSort: MatSort;
  @ViewChild('thirdPartySort') public thirdPartySort: MatSort;
  @ViewChild('sponsorSort') public sponsorSort: MatSort;

  participants: any = [];
  participantsSub: Subscription;
  creaPart: any;
  thirdPartyPart: any;

  creaColumns: string[] = ['role', 'participant'];
  creaDataSource: MatTableDataSource<CREATable>;

  thirdPartyColumns: string[] = ['role', 'participant', 'sponsor', 'repeat', 'tags'];
  thirdPartyColumnsLite: string[] = ['role'];
  thirdPartyDataSource: MatTableDataSource<ThirdPartyTable>;

  sponsorColumns: string[] = ['role', 'participant', 'repeat']
  sponsorDataSource: MatTableDataSource<SponsorTable>

  creaEditData: any[];
  thirdEditData: any[];
  sponsorEditData: any[];
  participantEditMode: Boolean = false;
  participantDeleteIds: any[] = [];
  participantUpdateIds: any[] = [];

  currentSearchResults: any = [];
  loadingSearchResults: Boolean = false;
  querySubscription: any;
  typeSubscription: Subscription = new Subscription();
  searchParticipant: FormControl = new FormControl('');
  searchParticipantSubs: any;
  searchParticipants: any;
  isMobile = false;

  constructor(
    private dataFormat: DataFormatService,
    private apiService: ApiService,
    private _snackBar: MatSnackBar,
    private env: EnvironmentService,
    public permsService: UserPermissionsService,
    private apollo: Apollo
  ) {}

  ngOnInit() {
    let newroles: any = []
    for (let i = 0; i < this.roles.length; i += 1) {
      newroles.push(this.roles[i]);
    }
    newroles.sort(function (x: any, y: any) {
      if (x.name < y.name) {
        return -1;
      }
      if (x.name > y.name) {
        return 1;
      }
      return 0;
    });
    this.roles = newroles;
    this.getPermsInBackground2();

    this.searchParticipants = { crea: [], third: [], sponsor: [] };
    this.searchParticipantSubs = { crea: [], third: [], sponsor: [] };
    this.isMobile = this.getIsMobile();
    window.onresize = () => {
      this.isMobile = this.getIsMobile();
    };
    this.participantsSub = this.participants$.subscribe((participants: any) => {
      this.participants = participants;
      this.formatParticipants(this.participants);
      this.formatParticipantsForEdit(this.participants);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty('participants')) {
      this.formatParticipants(changes['participants'].currentValue);
      this.formatParticipantsForEdit(changes['participants'].currentValue);
    }
  }

  getIsMobile(): boolean {
    const w = document.documentElement.clientWidth;
    const breakpoint = 1475;
    return w < breakpoint;
  }

  getPermsInBackground() {
    //We REALLY REALLY REALLY need to batch permissions calls but we can do it in the day 1 patch yall
    for (let i = 0; i < this.roles.length; i += 1) {
      let r = this.permsService.getUserPermissions('ROLE', this.roles[i].id);
    }
  }

  getPermsInBackground2() {
    let batch: any = [];
    for (let i = 0; i < this.roles.length; i += 1) {
      batch.push({ resourceType: 'ROLE', resourceId: this.roles[i].id });
    }
    this.permsService.getUserPermissionsBatch(batch);
  }

  ngAfterViewInit() {
    this.creaDataSource.sort = this.creaSort;
    this.thirdPartyDataSource.sort = this.thirdPartySort;
    this.sponsorDataSource.sort = this.sponsorSort;
  }

  getSearchParticipant(i: any, j: any, type: any, role_id: any, value?: any) {
    if (!this.searchParticipants) {
      this.searchParticipants = { crea: [], third: [], sponsor: [] };
      this.searchParticipantSubs = { crea: [], third: [], sponsor: [] };
    }
    if (!this.searchParticipants[type][i]) {
      this.searchParticipants[type][i] = [];
      this.searchParticipantSubs[type][i] = [];
    }
    if (!this.searchParticipants[type][i][j]) {
      this.searchParticipants[type][i][j] = new FormControl(value ? value : '');
    } else if (!this.searchParticipantSubs[type][i][j]) {
      this.searchParticipantSubs[type][i][j] = this.searchParticipants[type][i][
        j
      ].valueChanges
        .pipe(
          debounceTime(500), // Waiting for 500ms while you're typing
          distinctUntilChanged() // Prevents the emitting if the 'start' value and the 'end' value are the same
        )
        .subscribe((value: any) => {
          if (type === 'crea') {
            //this.creaEditData[i].data[j].participant = null;
          }
          if (type === 'third') {
            //this.thirdEditData[i].data[j].participant = null;
          }
          if (type === 'sponsor'){

          }
          this.searchParticipantText(role_id, value, type);
        });
    }

    if (!this.searchParticipantSubs[type][i][j]) {
      this.searchParticipantSubs[type][i][j] = this.searchParticipants[type][i][
        j
      ].valueChanges
        .pipe(
          debounceTime(500), // Waiting for 500ms while you're typing
          distinctUntilChanged() // Prevents the emitting if the 'start' value and the 'end' value are the same
        )
        .subscribe((value: any) => {
          this.searchParticipantText(role_id, value, type);
        });
    }
    return this.searchParticipants[type][i][j];
  }

  formatParticipants(part: any): any {
    let creaformat: Array<CREATable> = [];
    let thirdformat: Array<ThirdPartyTable> = [];
    let sponsorFormat: Array<SponsorTable> = [];

    for (let i = 0; i < part.length; i++) {
      let role = part[i].role.name;
      let partName = '';
      let link = '';
      if (part[i].person) {
        partName = part[i].person.name;
        link = this.dataFormat.formatLink(part[i].person);
      } else if(part[i].sponsor){
        partName = part[i].sponsor.name;
        link = this.dataFormat.formatLink(part[i].sponsor)
      } else {
        partName = part[i].organization.name;
        link = this.dataFormat.formatLink(part[i].organization);
      }

      if (part[i].role.roleType.name === 'CREA Project') {
        let isOriginated = null;
        if (role === 'Originator') {
          let relationship = null;
          if (
            this.developer &&
            this.developer[0] &&
            this.developer[0].organization.sponsor &&
            this.developer[0].organization.sponsor.originatorRelationship
          ) {
            relationship =
              this.developer[0].organization.sponsor.originatorRelationship;
          } else if (
            this.developer &&
            this.developer[0] &&
            this.developer[0].organization &&
            this.developer[0].organization.originatorRelationship
          ) {
            relationship =
              this.developer[0].organization.originatorRelationship;
          }

          if (relationship && relationship.person.id === part[i].person.id) {
            isOriginated = relationship.is_originated;
          }
        }

        creaformat.push({
          role: role,
          participant: partName,
          url: link,
          originatorRelationship: isOriginated,
        });
      } else if (part[i].role.roleType.name == "Deal Sponsor") {
        sponsorFormat.push({
          role: role,
          participant: partName,
          is_repeat: part[i].sponsor?.is_repeat ? "Yes" : "No",
          url: link
        })
      } else {
        let sponsor = '';
        let sponsorurl = '';
        let is_repeat = 'No';
        let tags = '';
        if (part[i].organization) {
          if (
            part[i].organization.sponsor &&
            part[i].organization.sponsor.name
          ) {
            sponsor = part[i].organization.sponsor.name;
            sponsorurl = this.dataFormat.formatLink(
              part[i].organization.sponsor
            );
          }
          if(part[i].organization?.sponsor?.is_repeat){
            is_repeat = 'Yes'
          }
          if (
            part[i].organization.entity.entity_types &&
            part[i].organization.entity.entity_types.length > 0
          ) {
            for (
              let j = 0;
              j < part[i].organization.entity.entity_types.length;
              j++
            ) {
              if (
                part[i]?.organization?.entity?.entity_types[j]?.type?.tagType
                  ?.name === 'descriptive'
              ) {
                if (tags !== '') {
                  tags += ', ';
                }
                tags += part[i].organization.entity.entity_types[j].type.name;
              }
            }
          }
        }

        thirdformat.push({
          role: role,
          participant: partName,
          url: link,
          sponsor: sponsor,
          sponsorurl: sponsorurl,
          is_repeat: is_repeat,
          tags: tags,
        });
      }
    }

    //Sort by role then participant name alphabetically
    function compare(a: any, b: any) {
      if (a.role === b.role) {
        if (a.participant < b.participant) {
          return -1;
        } else if (a.participant > b.participant) {
          return 1;
        } else {
          return 0;
        }
      } else if (a.role < b.role) {
        return -1;
      } else {
        return 1;
      }
    }

    creaformat.sort(compare);
    thirdformat.sort(compare);
    sponsorFormat.sort(compare);

    this.creaDataSource = new MatTableDataSource(creaformat);
    this.thirdPartyDataSource = new MatTableDataSource(thirdformat);
    this.sponsorDataSource = new MatTableDataSource(sponsorFormat)
  }

  editParticipants() {
    if (this.participantEditMode) {
      this.saveParticipants();
    }
    this.participantEditMode = !this.participantEditMode;
  }

  saveParticipants() {
    let updateData: any[] = [];
    let createData: any[] = [];
    for (let i = 0; i < this.creaEditData.length; i += 1) {
      for (let j = 0; j < this.creaEditData[i].data.length; j += 1) {
        let upId = this.creaEditData[i].data[j].participant
          ? this.creaEditData[i].data[j].participant.id
          : null;
        if (
          upId !== null &&
          this.creaEditData[i].data[j].id &&
          this.participantUpdateIds.includes(this.creaEditData[i].data[j].id)
        ) {
          let found = false;
          for (let k = 0; k < updateData.length; k += 1) {
            if (
              ((updateData[k].person && updateData[k].person.id === upId) ||
                (updateData[k].organization &&
                  updateData[k].organization.id === upId) || (updateData[k].sponsor && updateData[k].sponsor.id === upId)) &&
              updateData[k].role.id === this.creaEditData[i].role.id
            ) {
              found = true;
            }
          }
          if (!found) {
            updateData.push({
              id: this.creaEditData[i].data[j].id,
              person_id:
                this.creaEditData[i].data[j].participant.__typename === 'Person'
                  ? this.creaEditData[i].data[j].participant.id
                  : null,
              organization_id:
                this.creaEditData[i].data[j].participant.__typename ===
                'Organization'
                  ? this.creaEditData[i].data[j].participant.id
                  : null,
              sponsor_id:
                this.creaEditData[i].data[j].participant.__typename === 'Sponsor'
                  ? this.creaEditData[i].data[j].participant.id
                  : null,
              active: true,
              role_id: this.creaEditData[i].role.id,
            });
          }
        }
      }
    }
    for (let i = 0; i < this.creaEditData.length; i += 1) {
      for (let j = 0; j < this.creaEditData[i].data.length; j += 1) {
        let upId = this.creaEditData[i].data[j].participant
          ? this.creaEditData[i].data[j].participant.id
          : null;
        if (upId !== null && !this.creaEditData[i].data[j].id) {
          let found = false;
          for (let k = 0; k < updateData.length; k += 1) {
            if (
              ((updateData[k].person && updateData[k].person.id === upId) ||
                (updateData[k].organization &&
                  updateData[k].organization.id === upId) || (updateData[k].sponsor && updateData[k].sponsor.id === upId)) &&
              updateData[k].role.id === this.creaEditData[i].role.id
            ) {
              found = true;
            }
          }
          if (!found) {
            createData.push({
              person_id:
                this.creaEditData[i].data[j].participant.__typename === 'Person'
                  ? this.creaEditData[i].data[j].participant.id
                  : null,
              organization_id:
                this.creaEditData[i].data[j].participant.__typename ===
                'Organization'
                  ? this.creaEditData[i].data[j].participant.id
                  : null,
              sponsor_id:
                this.creaEditData[i].data[j].participant.__typename === 'Sponsor'
                  ? this.creaEditData[i].data[j].participant.id
                  : null,
              active: true,
              role_id: this.creaEditData[i].role.id,
            });
          }
        }
      }
    }

    for (let i = 0; i < this.thirdEditData.length; i += 1) {
      for (let j = 0; j < this.thirdEditData[i].data.length; j += 1) {
        let upId = this.thirdEditData[i].data[j].participant
          ? this.thirdEditData[i].data[j].participant.id
          : null;
        if (
          upId &&
          this.thirdEditData[i].data[j].id &&
          this.participantUpdateIds.includes(this.thirdEditData[i].data[j].id)
        ) {
          let found = false;
          for (let k = 0; k < updateData.length; k += 1) {
            if (
              ((updateData[k].person && updateData[k].person.id === upId) ||
                (updateData[k].organization &&
                  updateData[k].organization.id === upId) || (updateData[k].sponsor && updateData[k].sponsor.id === upId)) &&
              updateData[k].role.id === this.thirdEditData[i].role.id
            ) {
              found = true;
            }
          }
          if (!found) {
            updateData.push({
              id: this.thirdEditData[i].data[j].id,
              person_id:
                this.thirdEditData[i].data[j].participant.__typename ===
                'Person'
                  ? this.thirdEditData[i].data[j].participant.id
                  : null,
              organization_id:
                this.thirdEditData[i].data[j].participant.__typename ===
                'Organization'
                  ? this.thirdEditData[i].data[j].participant.id
                  : null,
              sponsor_id:
                this.thirdEditData[i].data[j].participant.__typename === 'Sponsor'
                  ? this.thirdEditData[i].data[j].participant.id
                  : null,
              active: true,
              role_id: this.thirdEditData[i].role.id,
            });
          }
        }
      }
    }
    for (let i = 0; i < this.thirdEditData.length; i += 1) {
      for (let j = 0; j < this.thirdEditData[i].data.length; j += 1) {
        let upId = this.thirdEditData[i].data[j].participant
          ? this.thirdEditData[i].data[j].participant.id
          : null;
        if (upId && !this.thirdEditData[i].data[j].id) {
          let found = false;
          for (let k = 0; k < updateData.length; k += 1) {
            if (
              ((updateData[k].person && updateData[k].person.id === upId) ||
                (updateData[k].organization &&
                  updateData[k].organization.id === upId) || (updateData[k].sponsor && updateData[k].sponsor.id === upId)) &&
              updateData[k].role.id === this.thirdEditData[i].role.id
            ) {
              found = true;
            }
          }
          if (!found) {
            createData.push({
              person_id:
                this.thirdEditData[i].data[j].participant.__typename ===
                'Person'
                  ? this.thirdEditData[i].data[j].participant.id
                  : null,
              organization_id:
                this.thirdEditData[i].data[j].participant.__typename ===
                'Organization'
                  ? this.thirdEditData[i].data[j].participant.id
                  : null,
              sponsor_id:
                this.thirdEditData[i].data[j].participant.__typename === 'Sponsor'
                  ? this.thirdEditData[i].data[j].participant.id
                  : null,
              active: true,
              role_id: this.thirdEditData[i].role.id,
            });
          }
        }
      }
    }
    for (let i = 0; i < this.sponsorEditData.length; i += 1) {
      for (let j = 0; j < this.sponsorEditData[i].data.length; j += 1) {
        let upId = this.sponsorEditData[i].data[j].participant
          ? this.sponsorEditData[i].data[j].participant.id
          : null;
        if (
          upId &&
          this.sponsorEditData[i].data[j].id &&
          this.participantUpdateIds.includes(this.sponsorEditData[i].data[j].id)
        ) {
          let found = false;
          for (let k = 0; k < updateData.length; k += 1) {
            if (
              ((updateData[k].person && updateData[k].person.id === upId) ||
                (updateData[k].organization &&
                  updateData[k].organization.id === upId) || (updateData[k].sponsor && updateData[k].sponsor.id === upId))  &&
              updateData[k].role.id === this.sponsorEditData[i].role.id
            ) {
              found = true;
            }
          }
          if (!found) {
            updateData.push({
              id: this.sponsorEditData[i].data[j].id,
              person_id:
                this.sponsorEditData[i].data[j].participant.__typename ===
                'Person'
                  ? this.sponsorEditData[i].data[j].participant.id
                  : null,
              organization_id:
                this.sponsorEditData[i].data[j].participant.__typename ===
                'Organization'
                  ? this.sponsorEditData[i].data[j].participant.id
                  : null,
              sponsor_id:
                this.sponsorEditData[i].data[j].participant.__typename === 'Sponsor'
                  ? this.sponsorEditData[i].data[j].participant.id
                  : null,
              active: true,
              role_id: this.sponsorEditData[i].role.id,
            });
          }
        }
      }
    }
    for (let i = 0; i < this.sponsorEditData.length; i += 1) {
      for (let j = 0; j < this.sponsorEditData[i].data.length; j += 1) {
        let upId = this.sponsorEditData[i].data[j].participant
          ? this.sponsorEditData[i].data[j].participant.id
          : null;
        if (upId && !this.sponsorEditData[i].data[j].id) {
          let found = false;
          for (let k = 0; k < updateData.length; k += 1) {
            if (
              ((updateData[k].person && updateData[k].person.id === upId) ||
                (updateData[k].organization &&
                  updateData[k].organization.id === upId) || (updateData[k].sponsor && updateData[k].sponsor.id)) &&
              updateData[k].role.id === this.thirdEditData[i].role.id
            ) {
              found = true;
            }
          }
          if (!found) {
            createData.push({
              person_id:
                this.sponsorEditData[i].data[j].participant.__typename ===
                'Person'
                  ? this.sponsorEditData[i].data[j].participant.id
                  : null,
              organization_id:
                this.sponsorEditData[i].data[j].participant.__typename ===
                'Organization'
                  ? this.sponsorEditData[i].data[j].participant.id
                  : null,
              sponsor_id:
                this.sponsorEditData[i].data[j].participant.__typename === 'Sponsor'
                  ? this.sponsorEditData[i].data[j].participant.id
                  : null,
              active: true,
              role_id: this.sponsorEditData[i].role.id,
            });
          }
        }
      }
    }
    this.apollo
      .mutate({
        mutation: UPDATE_PROJECT_PARTICIPANTS,
        variables: {
          input: {
            id: this.projectid,
            participants: {
              upsert: updateData.concat(createData),
              delete: this.participantDeleteIds,
            },
          },
        },
      })
      .subscribe(({ data }) => {
        // @ts-ignore
        let results = data.updateParticipants.participants;
        this.participants = results;
        this.participantsChange.emit(this.participants);
        this.formatParticipants(results);
        this.formatParticipantsForEdit(results);
        this.openSnackBar('Participants successfully saved.');
      });
    this.participantDeleteIds = [];
    this.participantUpdateIds = [];
  }

  addCREAParticipant(i: any) {
    let partRow = {
      id: null,
      active: true,
      participant: null,
      role: this.creaEditData[i].role,
    };
    this.creaEditData[i].data.push(partRow);
  }

  addThirdParticipant(i: any) {
    let partRow = {
      id: null,
      active: true,
      participant: null,
      role: this.thirdEditData[i].role,
    };
    this.thirdEditData[i].data.push(partRow);
  }

  addSponsorParticipant(i: any){
    let partRow = {
      id: null,
      active: true,
      participant: null,
      role: this.sponsorEditData[i].role
    }
    this.sponsorEditData[i].data.push(partRow)
  }

  updateCREAParticipant(i: any, j: any, val: any) {
    let id = this.creaEditData[i].data[j].id;
    if (
      this.creaEditData[i].data[j].id &&
      !this.participantUpdateIds.includes(this.creaEditData[i].data[j].id)
    ) {
      this.participantUpdateIds.push(this.creaEditData[i].data[j].id);
    }
    //val.id = id;
    this.creaEditData[i].data[j].participant = {
      __typename: val.participant.__typename,
      id: val.participant.id,
      name: val.participant.name + '',
    };
    this.currentSearchResults = [];
  }

  updateThirdParticipant(i: any, j: any, val: any) {
    if (
      this.thirdEditData[i].data[j].id &&
      !this.participantUpdateIds.includes(this.thirdEditData[i].data[j].id)
    ) {
      this.participantUpdateIds.push(this.thirdEditData[i].data[j].id);
    }
    this.thirdEditData[i].data[j].participant = {
      __typename: val.participant.__typename,
      id: val.participant.id,
      name: val.participant.name + '',
    };
    this.currentSearchResults = [];
    this.searchParticipant.setValue(null);
  }

  updateSponsorParticipant(i: any, j: any, val: any) {
    if(this.sponsorEditData[i].data[j].id && !this.participantUpdateIds.includes(this.sponsorEditData[i].data[j].id)){
      this.participantUpdateIds.push(this.sponsorEditData[i].data[j].id)
    }

    this.sponsorEditData[i].data[j].participant = {
      __typename: val.participant.__typename,
      id: val.participant.id,
      name: val.participant.name + ''
    };
    this.currentSearchResults = []
    this.searchParticipant.setValue(null)
  }

  deleteCREAParticipant(i: any, j: any) {
    if (
      this.creaEditData[i].data[j].id &&
      !this.participantDeleteIds.includes(this.creaEditData[i].data[j].id)
    ) {
      this.participantDeleteIds.push(this.creaEditData[i].data[j].id);
    }
    if (
      this.creaEditData[i].data[j].id &&
      this.participantUpdateIds.includes(this.creaEditData[i].data[j].id)
    ) {
      this.participantUpdateIds.splice(
        this.participantUpdateIds.indexOf(this.creaEditData[i].data[j].id),
        1
      );
    }
    this.searchParticipants['crea'][i][j].setValue('');
    this.creaEditData[i].data.splice(j, 1);
    if (this.creaEditData[i].data.length === 0) {
      this.addCREAParticipant(i);
    }
  }

  deleteThirdParticipant(i: any, j: any) {
    if (
      this.thirdEditData[i].data[j].id &&
      !this.participantDeleteIds.includes(this.thirdEditData[i].data[j].id)
    ) {
      this.participantDeleteIds.push(this.thirdEditData[i].data[j].id);
    }
    if (
      this.thirdEditData[i].data[j].id &&
      this.participantUpdateIds.includes(this.thirdEditData[i].data[j].id)
    ) {
      this.participantUpdateIds.splice(
        this.participantUpdateIds.indexOf(this.thirdEditData[i].data[j].id),
        1
      );
    }
    this.searchParticipants['third'][i][j].setValue('');
    this.thirdEditData[i].data.splice(j, 1);
    if (this.thirdEditData[i].data.length === 0) {
      this.addThirdParticipant(i);
    }
  }

  deleteSponsorParticipant(i: any, j: any) {
    if(this.sponsorEditData[i].data[j].id && !this.participantDeleteIds.includes(this.sponsorEditData[i].data[j].id)){
      this.participantDeleteIds.push(this.sponsorEditData[i].data[j].id)
    }

    if(this.sponsorEditData[i].data[j].id && this.participantUpdateIds.includes(this.sponsorEditData[i].data[j].id)){
      this.participantUpdateIds.splice(this.participantUpdateIds.indexOf(this.sponsorEditData[i].data[j].id), 1)
    }
    this.searchParticipants['sponsor'][i][j].setValue("");
    this.sponsorEditData[i].data.splice(j, 1);
    if (this.sponsorEditData[i].data.length === 0){
      this.addSponsorParticipant(i)
    }
  }

  initializeAutocomplete(role_id: any, type: string) {
    this.currentSearchResults = [];
    if (this.typeSubscription) {
      this.typeSubscription.unsubscribe();
    }
    this.typeSubscription = this.searchParticipant.valueChanges
      .pipe(
        debounceTime(500), // Waiting for 500ms while you're typing
        distinctUntilChanged() // Prevents the emitting if the 'start' value and the 'end' value are the same
      )
      .subscribe((value: any) => {
        this.searchParticipantText(role_id, value, type);
      });
  }

  searchParticipantText(role: any, searchText: any, type: string) {
    this.currentSearchResults = [];
    if (searchText?.length < 1) {
      return;
    }
    this.loadingSearchResults = true;
    if (this.querySubscription) {
      this.querySubscription.unsubscribe();
    }
    if (typeof searchText !== 'string') {
      return;
    }
    this.querySubscription = this.apollo
      .watchQuery<any>({
        query: PARTICIPANTS_SEARCH_PEOPLE,
        variables: {
          searchLike: '%' + searchText.trim() + '%',
          limit: 10,
          search: searchText.trim(),
          role: role.name,
        },
      })
      .valueChanges.subscribe(({ data }) => {
        this.loadingSearchResults = false;
        this.currentSearchResults = [];
        if(type!=='sponsor'){
          for (let i = 0; i < data.participant_orgs.data.length; i += 1) {
            let partRow: any = {
              active: true,
              person: null,
              participant: data.participant_orgs.data[i],
              role: role,
            };

            this.currentSearchResults.push(partRow);
          }
          for (let i = 0; i < data.participant_people.data.length; i += 1) {
            let partRow: any = {
              active: true,
              participant: data.participant_people.data[i],
              role: role,
            };
            this.currentSearchResults.push(partRow);
          }
        } else {
          for (let i = 0; i < data.participant_sponsors.data.length; i += 1){
            let partRow: any = {
              active: true,
              participant: data.participant_sponsors.data[i],
              role: role
            }
            this.currentSearchResults.push(partRow)
          }
        }


      });
  }

  openSnackBar(message: string) {
    const config = new MatSnackBarConfig();
    config.panelClass = ['save-success'];
    config.horizontalPosition = 'center';
    config.verticalPosition = 'top';
    config.duration = 3000;
    this._snackBar.open(message, 'Ok', config);
  }

  failSnackBar(message: string) {
    const config = new MatSnackBarConfig();
    config.panelClass = ['save-fail'];
    config.horizontalPosition = 'center';
    config.verticalPosition = 'top';
    config.duration = 3000;
    this._snackBar.open(message, 'Ok', config);
  }

  participantOptionText(opt: any) {
    if (typeof opt === 'string') {
      return opt;
    }
    let name = 'default';
    if (opt === undefined) {
      return '';
    }
    if (opt.person !== null && opt.person !== undefined && opt.person.name) {
      return opt.person.name;
    }
    if (
      opt.organization !== null &&
      opt.organization !== undefined &&
      opt.organization.name
    ) {
      return opt.organization.name;
    }
    if(opt.sponsor !== null && opt.sponsor !== undefined && opt.sponsor.name){
      return opt.sponsor.name
    }
    if (
      opt &&
      opt.participant !== null &&
      opt.participant !== undefined &&
      opt.participant.name !== null &&
      opt.participant.name !== undefined
    ) {
      return opt.participant.name;
    }
    if (opt && opt.participant === null) {
      return '';
    } else if (opt && opt.participant.person) {
      name = opt.participant.person.name;
    } else if (opt && opt.participant.organization) {
      name = opt.participant.organization.name;
    } else if (opt && opt.participant.sponsor){
      name = opt.participant.sponsor.name
    }
    return name;
  }

  formatParticipantsForEdit(parts: any[]) {
    this.creaEditData = [];
    this.thirdEditData = [];
    this.sponsorEditData = [];

    for (let i = 0; i < this.roles.length; i += 1) {
      let roleRow = {
        role: this.roles[i],
        data: [],
      };
      if (this.roles[i].roleType.name === 'CREA Project') {
        this.creaEditData.push(roleRow);
      }
      if (this.roles[i].roleType.name === 'Third Party') {
        this.thirdEditData.push(roleRow);
      }
      if (this.roles[i].roleType.name === 'Deal Sponsor') {
        this.sponsorEditData.push(roleRow)
      }
    }

    for (let i = 0; i < parts.length; i += 1) {
      let partRow = {
        id: parts[i].id,
        active: true,
        participant: parts[i],
        role: parts[i].role,
      };

      if (partRow.role.roleType.name === 'CREA Project') {
        for (let j = 0; j < this.creaEditData.length; j += 1) {
          if (partRow.role.id === this.creaEditData[j].role.id) {
            this.creaEditData[j].data.push(partRow);
          }
        }
      }
      if (partRow.role.roleType.name === 'Third Party') {
        for (let j = 0; j < this.thirdEditData.length; j += 1) {
          if (partRow.role.id === this.thirdEditData[j].role.id) {
            this.thirdEditData[j].data.push(partRow);
          }
        }
      }
      if (partRow.role.roleType.name === 'Deal Sponsor') {
        for (let j = 0; j < this.sponsorEditData.length; j += 1){
          if(partRow.role.id === this.sponsorEditData[j].role.id){
            this.sponsorEditData[j].data.push(partRow)
          }
        }
      }
    }

    for (let i = 0; i < this.creaEditData.length; i += 1) {
      let partRow = {
        id: null,
        active: true,
        participant: null,
        role: this.creaEditData[i].role,
      };
      if (this.creaEditData[i].data.length === 0) {
        this.creaEditData[i].data.push(partRow);
      }
    }

    for (let i = 0; i < this.thirdEditData.length; i += 1) {
      let partRow = {
        id: null,
        active: true,
        participant: null,
        role: this.thirdEditData[i].role,
      };
      if (this.thirdEditData[i].data.length === 0) {
        this.thirdEditData[i].data.push(partRow);
      }
    }

    for (let i = 0; i < this.sponsorEditData.length; i += 1){
      let partRow = {
        id: null,
        active: true,
        participant: null,
        role: this.sponsorEditData[i].role
      };
      if (this.sponsorEditData[i].data.length === 0){
        this.sponsorEditData[i].data.push(partRow)
      }
    }
  }

  isOriginatedFormat(val: boolean): string {
    if (val) {
      return '(Originated)';
    } else if (!val) {
      return '(Assigned)';
    }
    return '';
  }
}
